module.exports = __webpack_public_path__ + "static/media/temp_alert.ee6e4411.png";